import React from 'react'
import { useDispatch } from 'react-redux'
import { AbsoluteSpinner, Tile } from '../../../App/Components'
import { addPersonToAppointment } from '../../../Appointment/store/Actions'
import { useHistory } from '../../../Router'
import { IPerson } from '../../interface/IPerson'
import { IMenuActivity } from '../../../Menu/Store/IMenuActivity'

type Props = {
  customerActivities: IMenuActivity[]
  persons: IPerson[]
  isPreferredPersonPerActivity: boolean
  establishmentId: string
  customerIndex: number | undefined
  activityId: number | undefined
  returnPath: string
}

export const EligiblePerson: React.FC<Props> = ({
  customerActivities,
  persons,
  isPreferredPersonPerActivity,
  establishmentId,
  customerIndex,
  activityId,
  returnPath,
}) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const eligibleTilePress = (person: IPerson) => {
    if (isPreferredPersonPerActivity && activityId) {
      dispatch(addPersonToAppointment(customerIndex, person, activityId))
      return history.push(returnPath)
    }
    dispatch(addPersonToAppointment(customerIndex, person, undefined))
    return history.push(returnPath)
  }

  if (!persons) {
    return <AbsoluteSpinner />
  }

  const selectableActivities = customerActivities.filter(
    (activity) => activity.isPersonSelectable && activity.duration !== 0
  )

  const filteredPersons = persons.filter((person: IPerson) => {
    if (
      typeof customerActivities === 'undefined' ||
      person.isCabine ||
      !person.isVisibleOnline ||
      !person.isVisibleInCalender
    ) {
      return false
    }

    return selectableActivities.some((activity) =>
      person.activityIds.includes(activity.id)
    )
  })

  if (filteredPersons.length === 0) {
    history.replace(returnPath)
    return null
  }

  const eligiblePersons = filteredPersons.map((person: IPerson) => {
    // If selecting for specific activity make sure the person has knowledge for it
    if (
      isPreferredPersonPerActivity &&
      typeof activityId !== 'undefined' &&
      !person.activityIds.includes(activityId)
    ) {
      return null
    }

    const newImageUri = person.avatar.slice(6)

    return (
      <Tile
        key={person.id}
        title={person.firstName}
        image={newImageUri}
        link={`/${establishmentId}/appointment`}
        onPress={() => eligibleTilePress(person)}
      />
    )
  })

  return <>{eligiblePersons}</>
}
